define('common/ko/extension/checkEquals',['knockout', 'underscore'], function (ko, _) {
    ko.extenders.checkEquals = function(source) {
        var changedValue,
            s;

        return ko.pureComputed({read: function() {
            if(!s) {
                changedValue = ko.observable(source.peek());
                s = source.subscribe(function(value) {
                    if (!_.isEqual(value, changedValue())) {
                        changedValue(value);
                    }
                });
            }
            return changedValue();
        }, write: function(value) {
            source(value);
        }});
    };
});

